import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './msg.png';
const _withScopeId = n => (_pushScopeId("data-v-49d461b5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-column main-top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://video-h5.wqxsw.com/ttyd/img/search-icon.png",
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "search-input",
  placeholder: "输入剧名搜索",
  type: "text"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "msgImg",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_6 = {
  key: 0,
  class: "msgNum"
};
const _hoisted_7 = {
  key: 0,
  class: "page-banner"
};
const _hoisted_8 = ["src", "onClick"];
const _hoisted_9 = {
  class: "firm-menu flex"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "color-111 fsl13 mt8 font-w500",
  style: {
    "white-space": "nowrap"
  }
};
const _hoisted_13 = {
  class: "color-666 fsl11 mt6"
};
const _hoisted_14 = {
  class: "main-box",
  ref: "bookHome"
};
const _hoisted_15 = {
  class: "tree-menu flex"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://video-h5.wqxsw.com/ttyd/img/down-icon.png",
  alt: ""
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  style: {
    "width": "24px"
  }
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://video-h5.wqxsw.com/ttyd/img/down-icon.png",
  alt: ""
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  style: {
    "width": "24px"
  }
}, null, -1));
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "cover-box"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 0,
  class: "corner_tip"
};
const _hoisted_24 = {
  class: "corner-bottom"
};
const _hoisted_25 = {
  class: "book-info flex-column"
};
const _hoisted_26 = {
  class: "book-title color-222"
};
const _hoisted_27 = {
  class: "book-introduction"
};
const _hoisted_28 = {
  key: 0,
  class: "tags"
};
const _hoisted_29 = {
  class: "flex logos flex-justify-between"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "flex items-center"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  class: "color-555 fsl12"
};
const _hoisted_34 = {
  key: 1,
  class: "main-box"
};
const _hoisted_35 = {
  style: {
    display: 'flex',
    width: '100%',
    paddingTop: '20px'
  }
};
const _hoisted_36 = {
  style: {
    flex: 1,
    marginLeft: '16px'
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_popover = _resolveComponent("van-popover");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  const _component_van_skeleton_image = _resolveComponent("van-skeleton-image");
  const _component_van_skeleton_paragraph = _resolveComponent("van-skeleton-paragraph");
  const _component_van_skeleton = _resolveComponent("van-skeleton");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_popupNew = _resolveComponent("popupNew");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-page", {
      'no-scroll': $setup.menuPop.popupPush
    }])
  }, [_createVNode(_component_van_sticky, {
    "offset-top": 0
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("ul", {
      class: _normalizeClass(["tab-menu flex", {
        'app-active': $setup.isapp
      }])
    }, null, 2), _createElementVNode("div", {
      class: "search-box",
      onClick: _cache[1] || (_cache[1] = function () {
        return $setup.goSearch && $setup.goSearch(...arguments);
      })
    }, [_hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("div", {
      class: "msgIcon",
      onClick: _cache[0] || (_cache[0] = _withModifiers(function () {
        return $setup.goNewList && $setup.goNewList(...arguments);
      }, ["stop"]))
    }, [_hoisted_5, $setup.no_see_count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.no_see_count > 99 ? '99+' : $setup.no_see_count), 1)) : _createCommentVNode("", true)])])])]),
    _: 1
  }), $setup.pageData.banner.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_van_swipe, {
    class: "my-swipe",
    autoplay: 3000,
    "indicator-color": "white",
    onChange: $setup.swipeChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pageData.banner, (i, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: i.book_id
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: i.image,
          alt: "",
          srcset: "",
          onClick: $event => $setup.lookDetail(i, 'banner', index)
        }, null, 8, _hoisted_8)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["onChange"])])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.companyList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass([{
        'checked': $setup.type == item.company_type
      }, "flex-column items-center flex-justify-end"]),
      onClick: $event => $setup.changeTab(item.company_type, item.company_name)
    }, [_createElementVNode("img", {
      src: $setup.getCompanyInfo(item.company_type, 'logo'),
      alt: "",
      srcset: ""
    }, null, 8, _hoisted_11), _createElementVNode("span", _hoisted_12, _toDisplayString(item.company_name), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(item.icon_show ? item.icon_show : "".concat($setup.pageData.taskCountMap[item.company_type] || 0, " \u4E2A\u4EFB\u52A1")), 1)], 10, _hoisted_10);
  }), 128))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("ul", _hoisted_15, [_createVNode(_component_van_popover, {
    show: $setup.showPopover,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $setup.showPopover = $event),
    placement: "bottom-start",
    theme: "dark",
    actions: $setup.actions,
    offset: [0, 12],
    onSelect: _cache[3] || (_cache[3] = $event => $setup.onSelect($event, 'sort'))
  }, {
    reference: _withCtx(() => [_createElementVNode("li", null, [_createTextVNode(_toDisplayString($setup.menuPop.sortTxt) + " ", 1), _hoisted_16])]),
    _: 1
  }, 8, ["show", "actions"]), _hoisted_17, _createVNode(_component_van_popover, {
    show: $setup.showMenuPopover,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $setup.showMenuPopover = $event),
    offset: [0, 12],
    actions: $setup.actionsMenu,
    theme: "dark",
    placement: "bottom-start",
    onSelect: _cache[5] || (_cache[5] = $event => $setup.onSelect($event, 'sex'))
  }, {
    reference: _withCtx(() => [_createElementVNode("li", null, [_createTextVNode(_toDisplayString($setup.menuPop.sexTxt) + " ", 1), _hoisted_18])]),
    _: 1
  }, 8, ["show", "actions"]), _hoisted_19]), _createVNode(_component_van_pull_refresh, {
    modelValue: $setup.refreshing,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.refreshing = $event),
    onRefresh: $setup.onRefresh
  }, {
    default: _withCtx(() => [$setup.pageData.bookList.length ? (_openBlock(), _createBlock(_component_van_list, {
      key: 0,
      loading: $setup.loading,
      "onUpdate:loading": _cache[6] || (_cache[6] = $event => $setup.loading = $event),
      finished: $setup.finished,
      "onUpdate:finished": _cache[7] || (_cache[7] = $event => $setup.finished = $event),
      "immediate-check": false,
      "finished-text": "已加载全部~",
      ref: "checkbox",
      onLoad: $setup.onLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pageData.bookList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "list-item",
          onClick: $event => $setup.lookDetail(item, 'detail')
        }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
          src: item.coverWap,
          class: "list-image",
          radius: "6px"
        }, null, 8, _hoisted_22), item.corner_tip ? (_openBlock(), _createElementBlock("span", _hoisted_23, [_createVNode(_component_van_icon, {
          name: "/icon/bao-icon.png",
          size: "11"
        }), _createTextVNode(" " + _toDisplayString(item.corner_tip), 1)])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_24, _toDisplayString(item.sex == 1 ? '男频' : '女频'), 1)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(item.bookName), 1), _createElementVNode("div", _hoisted_27, _toDisplayString(item.introduction), 1), item.recharge_benefit ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("span", null, "充值：" + _toDisplayString(item.recharge_benefit), 1), _createElementVNode("span", null, "广告：" + _toDisplayString(item.ad_benefit), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.media_show_list, (l, index) => {
          return _openBlock(), _createElementBlock("img", {
            key: index,
            src: $setup.mediaEnu[l + '-medialogo'],
            alt: ""
          }, null, 8, _hoisted_30);
        }), 128))]), _createElementVNode("div", _hoisted_31, [_createElementVNode("img", {
          style: {
            "margin-right": "2px"
          },
          src: $setup.getCompanyInfo(item.company_type, 'logo'),
          alt: ""
        }, null, 8, _hoisted_32), _createElementVNode("span", _hoisted_33, _toDisplayString($setup.getCompanyInfo(item.company_type, 'name')), 1)])])])], 8, _hoisted_20);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])], 512), $setup.pageData.bookList.length == 0 && !$setup.isOver ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_van_skeleton, {
    style: {
      display: 'inherit'
    }
  }, {
    template: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, i => {
      return _createElementVNode("div", {
        key: i
      }, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_van_skeleton_image, {
        style: {
          background: '#fff'
        }
      }), _createElementVNode("div", _hoisted_36, [_createVNode(_component_van_skeleton_paragraph, {
        "row-width": "60%",
        style: {
          background: '#fff'
        }
      }), _createVNode(_component_van_skeleton_paragraph, {
        style: {
          background: '#fff'
        }
      }), _createVNode(_component_van_skeleton_paragraph, {
        style: {
          background: '#fff'
        }
      }), _createVNode(_component_van_skeleton_paragraph, {
        style: {
          background: '#fff'
        }
      })])])]);
    }), 64))]),
    _: 1
  })])) : _createCommentVNode("", true), !$setup.pageData.bookList.length && $setup.isOver ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["main-box", {
      'app-active': $setup.isapp
    }])
  }, [_createVNode(_component_van_empty, {
    style: {
      "margin-top": "100px"
    },
    description: "抱歉，没有找到符合条件的短剧"
  })], 2)) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
    show: $setup.menuPop.popupPush,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $setup.menuPop.popupPush = $event),
    "transition-appear": true,
    style: {
      width: '311px',
      borderRadius: '8px',
      overflow: 'inherit'
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_popupNew, {
      popupData: $setup.pageData.notice,
      onCloseEvent: $setup.closeFun
    }, null, 8, ["popupData", "onCloseEvent"])]),
    _: 1
  }, 8, ["show"])], 2);
}